<template>
  <template v-if="members">
    <PageContainer>
      <MemberWrapper>
        <BandMember
          v-for="(member, index) in members"
          v-bind:key="'member-view-' + index"
          :member="member"
        />
      </MemberWrapper>
    </PageContainer>
  </template>
  <template v-else>
    <PageContainer>
      <TextLoader />
    </PageContainer>
  </template>
</template>

<script>
import PageContainer from "@/components/Wrapper/PageContainer";
import TextLoader from "@/components/Loader/TextLoader";
import BandMember from "@/components/Items/BandMember";
import MemberWrapper from "@/components/Wrapper/MemberWrapper";
export default {
  name: "BandMembers",
  components: { MemberWrapper, BandMember, TextLoader, PageContainer },
  data() {
    return {
      members: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.axios
        .get("/api/content/items/band_2", {
          params: { populate: 2, sort: JSON.stringify({ pos: 1 }) },
        })
        .then((r) => {
          this.members = r.data;
        });
    },
  },
};
</script>

<style scoped></style>
